module.exports = __webpack_public_path__ + "static/img/qyjr32.c6893cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyjr32.jpg
// module id = V48N
// module chunks = 73